import { formatDate } from '../lib/format.js';

/**
 * The signed-in user's saved tickers.
 *
 * @param {{history: {status: string, items: Array<{id: number|string, ticker: string, timestamp: string}>,
 *   error: string | null, remove: (ticker: string) => Promise<void>},
 *   signedIn: boolean, selectedTicker: string | null,
 *   onSelect: (ticker: string) => void, onRequestSignIn: () => void}} props
 */
export default function HistoryPanel({ history, signedIn, selectedTicker, onSelect, onRequestSignIn }) {
  const { status, items, error, remove } = history;

  return (
    <section className="panel">
      <header className="panel-heading">
        <h2 className="panel-title">My history</h2>
        <span className="font-mono text-[11px] text-slate-500">{items.length}</span>
      </header>

      {!signedIn ? (
        <div className="flex flex-col gap-3 px-4 py-5">
          <p className="text-sm text-slate-500">
            Sign in to keep a personal shortlist of the tickers you follow.
          </p>
          <button type="button" className="btn-ghost self-start" onClick={onRequestSignIn}>
            Sign in
          </button>
        </div>
      ) : error ? (
        <p className="px-4 py-5 text-sm text-bear">{error}</p>
      ) : status === 'loading' && items.length === 0 ? (
        <p className="px-4 py-5 text-sm text-slate-500">Loading…</p>
      ) : items.length === 0 ? (
        <p className="px-4 py-5 text-sm text-slate-500">
          Nothing saved yet — open a ticker and press <span className="text-slate-300">Save</span>.
        </p>
      ) : (
        <ul className="flex max-h-80 flex-col overflow-y-auto scrollbar-thin">
          {items.map((item) => (
            <li
              key={item.id ?? item.ticker}
              className={`flex items-center justify-between gap-2 border-b border-terminal-800 px-4 py-2 last:border-b-0 ${
                selectedTicker === item.ticker ? 'bg-terminal-850/70' : ''
              }`}
            >
              <button
                type="button"
                className="flex min-w-0 flex-col text-left"
                onClick={() => onSelect(item.ticker)}
              >
                <span className="font-mono text-sm text-slate-100">{item.ticker}.NS</span>
                <span className="text-[11px] text-slate-500">{formatDate(item.timestamp)}</span>
              </button>
              <button
                type="button"
                aria-label={`Remove ${item.ticker} from history`}
                className="rounded-md border border-transparent px-2 py-1 text-xs text-slate-500 hover:border-bear/40 hover:text-bear"
                onClick={() => remove(item.ticker)}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
